import React, { Suspense, lazy } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom'; // Import HashRouter
import '@aws-amplify/ui-react/styles.css';
import './App.css';

const Ridella = lazy(() => import('./Ridella'));
const About = lazy(() => import('./Ridella/About'));
const GlobalStats = lazy(() => import('./Ridella/GlobalStats'));
const Archive = lazy(() => import('./Ridella/Archive'));
const NotFound = lazy(() => import('./pages/NotFound'));


const App = () => (
  <HashRouter> {/* Use HashRouter here */}
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Ridella />} />
        <Route path="/about" element={<About />} />
        <Route path="/globalstats" element={<GlobalStats />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  </HashRouter>
);

export default App;
